(function () {

    RestBetweenDaysService.$inject = ['$q', 'ScheduleDataServiceV2', 'ScheduleCostsServiceV2'];

    function RestBetweenDaysService ($q, ScheduleDataServiceV2, ScheduleCostsServiceV2) {
        var self = this;

        var getUserShifts = function (shiftsList, userId) {
            return shiftsList.filter(function (shift) {
                return (shift['user_id'] === userId && shift['status'] !== 'DELETED');
            });
        };

        var isCoveredUser = function (userPayType, rulePayTypes) {
            return rulePayTypes.findIndex(function (payType) {
                return payType['payment_type'] === userPayType;
            }) > -1;
        };

        self.calculateRestBetweenDaysWarnings = function () {
            var defer = $q.defer();
            var restBetweenDaysRule = ScheduleDataServiceV2.getRestBetweenDaysRule();

            if (restBetweenDaysRule && restBetweenDaysRule['rest_period'] > 0) {
                ScheduleCostsServiceV2
                    .getUsersCostsMap()
                    .then(function (usersCostsMap) {
                        var restBetweenDayList = [];
                        var scheduledUsers = ScheduleDataServiceV2.flatData['users'] || {};
                        var scheduledShifts = Object.values(ScheduleDataServiceV2.flatData['shifts']) || [];
                        var dayBeforeScheduledShifts = Object.values(ScheduleDataServiceV2.extraDayFlatData['shifts']) || [];

                        for (var i in scheduledUsers) {
                            var userId = scheduledUsers[i]['id'];
                            var userCosts = usersCostsMap[userId] || {};

                            if (userId === null) {
                                continue;
                            }

                            var userShifts = getUserShifts(scheduledShifts, userId);
                            var userDayBeforeShifts = getUserShifts(dayBeforeScheduledShifts, userId);
                            var userCrossScheduleShifts = [];
                            var userDayBeforeCrossScheduleShifts = [];
                            var allUserShifts = userDayBeforeShifts.concat(userShifts);
                            var shiftsToCompare = userShifts;

                            for (var c in ScheduleDataServiceV2.crossFlatData) {
                                var crossBrandShifts = Object.values(ScheduleDataServiceV2.crossFlatData[c]['shifts']) || [];
                                var userBrandCrossShifts = getUserShifts(crossBrandShifts, userId);
                                userCrossScheduleShifts = userCrossScheduleShifts.concat(userBrandCrossShifts);
                                allUserShifts = allUserShifts.concat(userCrossScheduleShifts);
                                shiftsToCompare = shiftsToCompare.concat(userCrossScheduleShifts);
                            }

                            for (var bc in ScheduleDataServiceV2.extraCrossDayFlatData['brands']) {
                                var dayBeforeCrossBrandShifts = ScheduleDataServiceV2.extraCrossDayFlatData['brands'][bc]['shifts'] && Object.values(ScheduleDataServiceV2.extraCrossDayFlatData['brands'][bc]['shifts']) || [];
                                var userDayBeforeBrandCrossShifts = getUserShifts(dayBeforeCrossBrandShifts, userId);
                                userDayBeforeCrossScheduleShifts = userDayBeforeCrossScheduleShifts.concat(userDayBeforeBrandCrossShifts);
                                allUserShifts = allUserShifts.concat(userDayBeforeCrossScheduleShifts);
                            }

                            var sortedShifts = allUserShifts.sort(function (shift1, shift2) {
                                return new Date(shift1.start_time).getTime() > new Date(shift2.start_time).getTime() ? 1 : -1;
                            });

                            for (var s in sortedShifts) {
                                var shift = sortedShifts[s];
                                var shiftUserPayType = userCosts["pay_type"] && userCosts["pay_type"][shift.day];

                                var isShiftCovered = isCoveredUser(shiftUserPayType && shiftUserPayType['type'], restBetweenDaysRule['pay_types']);

                                for (var cs in shiftsToCompare) {
                                    var comparedShift = shiftsToCompare[cs];
                                    var comparedShiftUserPayType = userCosts["pay_type"] && userCosts["pay_type"][comparedShift.day];

                                    var isComparedShiftCovered = isCoveredUser(comparedShiftUserPayType && comparedShiftUserPayType['type'], restBetweenDaysRule['pay_types']);

                                    if(!isShiftCovered && !isComparedShiftCovered) {
                                        continue;
                                    }

                                    var differenceInSeconds = moment(comparedShift.start_time).diff(shift.end_time, 'seconds');
                                    var onSameDay = moment(comparedShift.start_time).isSame(moment(shift.start_time), 'days');

                                    if (
                                        comparedShift.id !== shift.id &&
                                        !onSameDay &&
                                        !comparedShift.cross_location &&
                                        differenceInSeconds > 0 &&
                                        differenceInSeconds < restBetweenDaysRule['rest_period']
                                    ) {
                                        restBetweenDayList.push({
                                            userId: userId,
                                            fromShift: shift,
                                            toShift: comparedShift,
                                            difference: differenceInSeconds,
                                            restPeriod: restBetweenDaysRule['rest_period']
                                        });
                                    }
                                }
                            }
                        }

                        defer.resolve(restBetweenDayList);
                    });
            } else {
                defer.resolve([]);
            }

            return defer.promise;
        };
    }

    app.service('restBetweenDaysService', RestBetweenDaysService);
}());